const data = [
  {
    id: 1,
    types: 'types__1',
    img: 'https://celes.club/uploads/posts/2021-12/1640090749_5-celes-club-p-zhivotnie-v-derevne-zhivotnie-krasivo-foto-6.jpg',
    title: 'usefulMaterial',
    date: '12 февраля 204'
  },
  {
    id: 2,
    types: 'types__2',
    img: 'https://celes.club/uploads/posts/2021-12/1640090810_4-celes-club-p-zhivotnie-v-derevne-zhivotnie-krasivo-foto-4.jpg',
    title: 'usefulMaterial',
    date: '12 февраля 2024'
  },
  {
    id: 3,
    types: 'types__3',
    img: 'https://celes.club/uploads/posts/2021-12/1640090779_2-celes-club-p-zhivotnie-v-derevne-zhivotnie-krasivo-foto-2.jpg',
    title: 'usefulMaterial',
    date: '12 февраля 2024'
  },
  {
    id: 4,
    types: 'types__4',
    img: 'https://celes.club/uploads/posts/2021-12/1640090778_3-celes-club-p-zhivotnie-v-derevne-zhivotnie-krasivo-foto-3.jpg',
    title: 'usefulMaterial',
    date: '12 февраля 2024'
  },
  {
    id: 5,
    types: 'types__5',
    img: 'https://celes.club/uploads/posts/2021-12/1640090732_1-celes-club-p-zhivotnie-v-derevne-zhivotnie-krasivo-foto-1.jpg',
    title: 'usefulMaterial',
    date: '12 февраля 2024'
  }
]

export default data